import { accordionAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers, } from "@chakra-ui/react";
import { textStyles, colors } from "../../../../theme/foundations/generated";
import { AccordionVariant } from "../Accordion.type";
const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(accordionAnatomy.keys);
const baseStyle = definePartsStyle(({ isOpen }) => ({
    root: {
        backgroundColor: "semantic.surface.1",
    },
    container: {
        borderTopWidth: "0",
        borderBottomWidth: "0.0625rem",
        borderColor: "semantic.border.secondary",
    },
    button: {
        paddingX: "1.5rem",
        paddingY: "1.25rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        _hover: {
            background: "none",
        },
        _focusVisible: {
            boxShadow: `inset 0 0 0 3px ${colors.semantic.outline.focus}`,
        },
    },
    title: Object.assign({ color: "semantic.text.primary", textAlign: "left" }, textStyles.body.largeDemibold),
    panel: {
        paddingTop: "0",
        paddingX: "1.5rem",
        paddingBottom: "2rem",
    },
    icon: {
        transitionDuration: "normal",
        transitionProperty: "common",
        width: "1.5rem",
        height: "1.5rem",
        color: "semantic.interactive.primary",
        transform: isOpen ? "rotate(-180deg)" : "rotate:(0deg)",
    },
}));
const variants = {
    [AccordionVariant.DEFAULT]: definePartsStyle({}),
    [AccordionVariant.REVERSE]: definePartsStyle({
        button: {
            display: "flex",
            flexDirection: "row-reverse",
            justifyContent: "flex-end",
            span: { pl: 4, flex: 1 },
        },
        container: {
            border: "none",
        },
    }),
    [AccordionVariant.CENTERED]: definePartsStyle({
        button: {
            justifyContent: "center",
            paddingY: "2",
            span: {
                color: "semantic.cta.secondary",
            },
        },
        icon: { color: "semantic.cta.secondary" },
        container: {
            border: "none",
        },
        title: Object.assign({}, textStyles.body.mediumBold),
    }),
};
const AccordionTheme = defineMultiStyleConfig({
    baseStyle,
    variants,
    defaultProps: { size: "default", variant: AccordionVariant.DEFAULT },
});
export default AccordionTheme;
//# sourceMappingURL=Accordion.default.js.map